import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, " − ", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 2,
  class: "qty"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, " + ", -1)
const _hoisted_8 = [
  _hoisted_7
]

import { ref, computed, watch } from 'vue';
import { useScreenSize } from '@/composables/useScreenSize';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseInputQuantity',
  props: {
    modelValue: { default: 0 },
    min: { default: 0 },
    max: { default: 9999 },
    noInput: { type: Boolean, default: false },
    inputClass: { default: '' },
    hideButton: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    isError: { type: Boolean, default: false },
    grouped: { type: Boolean, default: false },
    hideButtonDesktop: { type: Boolean, default: true }
  },
  emits: ['update:modelValue', 'add', 'minus', 'blur', 'change'],
  setup(__props: any, { emit }) {

const props = __props;

const { isDesktop } = useScreenSize();



const currentValue = ref(props.modelValue);
const isFocus = ref(false);

// Computed
const currentValueDisplay = computed(() => {
  if (!isFocus.value) {
    return currentValue.value;
  }

  return currentValue.value !== 0
    ? currentValue.value
    : '';
});

// Watchers
watch(() => props.modelValue, (newValue) => {
  currentValue.value = newValue;
});

// Methods
function filterQtyKey(e: KeyboardEvent){
  const key = e.key;
  // If is '.' key, stop it
  if (key === '.')
    return e.preventDefault();
  if (key === '+')
    return e.preventDefault();
  if (key === '-')
    return e.preventDefault();
  // OPTIONAL
  // If is 'e' key, stop it
  if (key === 'e')
    return e.preventDefault();
}

function onMinusInputQty() {
  if (props.min !== 0 && props.min > currentValue.value - 1) {
    currentValue.value = props.min;
    emit('update:modelValue', currentValue.value);
    emit('change', currentValue.value);
    return;
  }
  if (props.modelValue <= 0) {
    return;
  }
  emit('minus');
  currentValue.value--;
  emit('update:modelValue', currentValue.value);
  emit('change', currentValue.value);
}
function onAddInputQty() {
  if (props.max !== 9999 && props.max < currentValue.value + 1) {
    currentValue.value = props.max;
    emit('update:modelValue', currentValue.value);
    emit('change', currentValue.value);
    return;
  }
  emit('add');
  currentValue.value++;
  emit('update:modelValue', currentValue.value);
  emit('change', currentValue.value);
}

function onChange(e: Event) {
  const element = e.target as HTMLInputElement;
  let getNumber;
  if (element.value === '') {
    getNumber = 0;
  } else {
    getNumber = parseInt(element.value);
  }
  if (props.max !== 9999 && props.max < getNumber) {
    getNumber = props.max;
  } else if (props.min !== 0 && props.min > getNumber) {
    getNumber = props.min;
  }
  emit('update:modelValue', getNumber);
  emit('change', getNumber);
}
function onInput(e: Event) {
  const element = e.target as HTMLInputElement;
  let getNumber;
  if (element.value === '') {
    getNumber = 0;
  } else {
    getNumber = parseInt(element.value);
  }
  if (props.max !== 9999 && props.max < getNumber) {
    getNumber = props.max;
  } else if (props.min !== 0 && props.min > getNumber) {
    getNumber = props.min;
  }
  emit('update:modelValue', getNumber);
}
function onBlur() {
  isFocus.value = false;
  emit('blur', currentValue.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'flex items-center base-input-qty',
      _ctx.grouped ? 'grouped' : null
    ])
  }, [
    (!_ctx.hideButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: _normalizeClass([
        'minus-btn',
        _unref(isDesktop) && _ctx.hideButtonDesktop ? 'is-desktop' : null
      ]),
          disabled: _ctx.disabled,
          onClick: onMinusInputQty
        }, _hoisted_3, 10, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.$slots['custom-input'])
      ? _renderSlot(_ctx.$slots, "custom-input", {
          key: 1,
          currentValue: currentValue.value,
          filterQtyKey: filterQtyKey,
          input: onInput,
          onChange: onChange
        })
      : (_ctx.noInput)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(currentValue.value), 1))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 3,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentValueDisplay).value = $event)),
            type: "number",
            step: "1",
            min: "0",
            class: _normalizeClass([
        'qty-input',
        _ctx.inputClass,
        _ctx.isError ? 'bg-red-100' : null,
      ]),
            disabled: _ctx.disabled,
            onKeydown: filterQtyKey,
            onInput: onInput,
            onChange: onChange,
            onFocus: _cache[1] || (_cache[1] = ($event: any) => (isFocus.value = true)),
            onBlur: onBlur
          }, null, 42, _hoisted_5)), [
            [_vModelText, currentValueDisplay.value]
          ]),
    (!_ctx.hideButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 4,
          type: "button",
          class: _normalizeClass([
        'add-btn',
        _unref(isDesktop) && _ctx.hideButtonDesktop ? 'is-desktop' : null
      ]),
          disabled: _ctx.disabled,
          onClick: onAddInputQty
        }, _hoisted_8, 10, _hoisted_6))
      : _createCommentVNode("", true)
  ], 2))
}
}

})